import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import * as consentActions from '../actions/consent.actions';
import { Consent } from '../model/consent.model';

import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ConsentEffects {

    /**
     * This is important - when consent is not loaded due to an error then the main app route is not activated (see
     * app-routing.module.ts and applications-routing.module.ts) - app
     * route is guarded by ConsentGuard which allows to load route only if there is a (any!!!) value in the store for
     * consent.
     * YouTrack: SSF-226 Nezobrazuje se stranka Unauhorized pri pouziti spatneho IBHashe
     */
    @Effect() enableRedirectToErrorScreen$ = this.actions$
        .ofType(consentActions.LOAD_ERROR)
        .map(() => new consentActions.LoadSuccessAction(<Consent>{consent: false}));

    constructor(private actions$: Actions) {}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/effects/consent.effects.ts